const isDBConnection = function (user_id) {
  const auth0 = 'auth0';
  if (!user_id) {
    return false;
  }
  const provider = user_id.split('|')[0];
  return provider === auth0 || provider.indexOf(auth0) !== -1;
};
export default isDBConnection;